/**
 * Generated by orval v6.11.1 🍺
 * Do not edit manually.
 * Blueprint: Public API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useMutation
} from 'react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from 'react-query'
import type {
  ClientInviteLookupResponseV1,
  ApiExceptionDto,
  ClientInviteControllerV1PostLookupBody,
  ClientInviteVerifyResponseV1,
  ClientInviteControllerV1PostVerifyBody,
  ClientInviteSetupAccountResponseV1,
  ClientInviteSetupAccountBodyV1,
  AssessmentDto,
  AssessmentControllerV1GetAssessmentsParams
} from './models'
import { coreApiInstance } from '../../axios-instance';
import type { ErrorType } from '../../axios-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const clientInviteControllerV1PostLookup = (
    clientInviteControllerV1PostLookupBody: ClientInviteControllerV1PostLookupBody,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<ClientInviteLookupResponseV1>(
      {url: `/v1/public-api/client-invite/lookup`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: clientInviteControllerV1PostLookupBody
    },
      options);
    }
  


    export type ClientInviteControllerV1PostLookupMutationResult = NonNullable<Awaited<ReturnType<typeof clientInviteControllerV1PostLookup>>>
    export type ClientInviteControllerV1PostLookupMutationBody = ClientInviteControllerV1PostLookupBody
    export type ClientInviteControllerV1PostLookupMutationError = ErrorType<ApiExceptionDto>

    export const useClientInviteControllerV1PostLookup = <TError = ErrorType<ApiExceptionDto>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientInviteControllerV1PostLookup>>, TError,{data: ClientInviteControllerV1PostLookupBody}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientInviteControllerV1PostLookup>>, {data: ClientInviteControllerV1PostLookupBody}> = (props) => {
          const {data} = props ?? {};

          return  clientInviteControllerV1PostLookup(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof clientInviteControllerV1PostLookup>>, TError, {data: ClientInviteControllerV1PostLookupBody}, TContext>(mutationFn, mutationOptions);
    }
    
export const clientInviteControllerV1PostVerify = (
    clientInviteControllerV1PostVerifyBody: ClientInviteControllerV1PostVerifyBody,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<ClientInviteVerifyResponseV1>(
      {url: `/v1/public-api/client-invite/verify`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: clientInviteControllerV1PostVerifyBody
    },
      options);
    }
  


    export type ClientInviteControllerV1PostVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof clientInviteControllerV1PostVerify>>>
    export type ClientInviteControllerV1PostVerifyMutationBody = ClientInviteControllerV1PostVerifyBody
    export type ClientInviteControllerV1PostVerifyMutationError = ErrorType<ApiExceptionDto>

    export const useClientInviteControllerV1PostVerify = <TError = ErrorType<ApiExceptionDto>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientInviteControllerV1PostVerify>>, TError,{data: ClientInviteControllerV1PostVerifyBody}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientInviteControllerV1PostVerify>>, {data: ClientInviteControllerV1PostVerifyBody}> = (props) => {
          const {data} = props ?? {};

          return  clientInviteControllerV1PostVerify(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof clientInviteControllerV1PostVerify>>, TError, {data: ClientInviteControllerV1PostVerifyBody}, TContext>(mutationFn, mutationOptions);
    }
    
export const clientInviteControllerV1PostSetupAccount = (
    clientInviteSetupAccountBodyV1: ClientInviteSetupAccountBodyV1,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<ClientInviteSetupAccountResponseV1>(
      {url: `/v1/public-api/client-invite/setup-account`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: clientInviteSetupAccountBodyV1
    },
      options);
    }
  


    export type ClientInviteControllerV1PostSetupAccountMutationResult = NonNullable<Awaited<ReturnType<typeof clientInviteControllerV1PostSetupAccount>>>
    export type ClientInviteControllerV1PostSetupAccountMutationBody = ClientInviteSetupAccountBodyV1
    export type ClientInviteControllerV1PostSetupAccountMutationError = ErrorType<ApiExceptionDto>

    export const useClientInviteControllerV1PostSetupAccount = <TError = ErrorType<ApiExceptionDto>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientInviteControllerV1PostSetupAccount>>, TError,{data: ClientInviteSetupAccountBodyV1}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientInviteControllerV1PostSetupAccount>>, {data: ClientInviteSetupAccountBodyV1}> = (props) => {
          const {data} = props ?? {};

          return  clientInviteControllerV1PostSetupAccount(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof clientInviteControllerV1PostSetupAccount>>, TError, {data: ClientInviteSetupAccountBodyV1}, TContext>(mutationFn, mutationOptions);
    }
    
export const userControllerV1GetSafetyNet = (
    userId: string,
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<void>(
      {url: `/v1/public-api/user/${userId}/safety-net`, method: 'get', signal
    },
      options);
    }
  

export const getUserControllerV1GetSafetyNetQueryKey = (userId: string,) => [`/v1/public-api/user/${userId}/safety-net`];

    
export type UserControllerV1GetSafetyNetQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerV1GetSafetyNet>>>
export type UserControllerV1GetSafetyNetQueryError = ErrorType<unknown>

export const useUserControllerV1GetSafetyNet = <TData = Awaited<ReturnType<typeof userControllerV1GetSafetyNet>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerV1GetSafetyNet>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerV1GetSafetyNetQueryKey(userId);

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerV1GetSafetyNet>>> = ({ signal }) => userControllerV1GetSafetyNet(userId, requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof userControllerV1GetSafetyNet>>, TError, TData>(queryKey, queryFn, {enabled: !!(userId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const assessmentControllerV1GetAssessments = (
    params: AssessmentControllerV1GetAssessmentsParams,
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<AssessmentDto[]>(
      {url: `/v1/public-api/assessments`, method: 'get',
        params, signal
    },
      options);
    }
  

export const getAssessmentControllerV1GetAssessmentsQueryKey = (params: AssessmentControllerV1GetAssessmentsParams,) => [`/v1/public-api/assessments`, ...(params ? [params]: [])];

    
export type AssessmentControllerV1GetAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof assessmentControllerV1GetAssessments>>>
export type AssessmentControllerV1GetAssessmentsQueryError = ErrorType<unknown>

export const useAssessmentControllerV1GetAssessments = <TData = Awaited<ReturnType<typeof assessmentControllerV1GetAssessments>>, TError = ErrorType<unknown>>(
 params: AssessmentControllerV1GetAssessmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof assessmentControllerV1GetAssessments>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssessmentControllerV1GetAssessmentsQueryKey(params);

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof assessmentControllerV1GetAssessments>>> = ({ signal }) => assessmentControllerV1GetAssessments(params, requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof assessmentControllerV1GetAssessments>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


